import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ApiError, api } from "../api";

export function Login() {
  const navigate = useNavigate();
  const [stage, setStage] = useState<"password" | "totp">("password");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (stage === "password") {
        const result = await api.post<{ totp_required: boolean }>("/api/auth/login", {
          email,
          password,
        });
        if (result.totp_required) {
          setStage("totp");
          return;
        }
      } else {
        await api.post("/api/auth/totp/verify", { code });
      }
      navigate("/services", { replace: true });
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : "Something went wrong");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="shell">
      <form className="form stack" onSubmit={submit}>
        <div>
          <p className="wordmark" style={{ fontSize: "var(--step-1)" }}>
            IronForge<span> / control</span>
          </p>
          <h1 style={{ fontSize: "var(--step-2)" }}>
            {stage === "password" ? "Sign in" : "Two-factor code"}
          </h1>
          <p className="lede">
            {stage === "password"
              ? "Manage your servers, containers and hosting."
              : "Enter the six-digit code from your authenticator app."}
          </p>
        </div>

        {error && (
          <p className="notice notice--error" role="alert">
            {error}
          </p>
        )}

        {stage === "password" ? (
          <>
            <label className="field">
              <span className="label">Email</span>
              <input
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <label className="field">
              <span className="label">Password</span>
              <input
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
          </>
        ) : (
          <label className="field">
            <span className="label">Authentication code</span>
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              pattern="[0-9]*"
              maxLength={6}
              required
              autoFocus
              className="mono"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </label>
        )}

        <button type="submit" className="btn btn--primary" disabled={busy}>
          {busy ? "Checking…" : stage === "password" ? "Sign in" : "Verify"}
        </button>
      </form>
    </main>
  );
}
